const missionControl = {
  header: {
    title: 'מרכז השליטה',
    createScenario: 'בנה תרחיש חדש',
  },

  cards: {
    titles: {
      co2Savings: 'חיסכון בפליטת CO2',
      onTimePerfformance: 'ביצוע בזמן',
      vehicleEfficiency: 'יעילות רכב',
      passengerSatisfaction: 'שביעות רצון נוסעים',
      costPerMile: 'עלות למייל',
    },
  },

  layers: {
    title: 'שכבת מפה',

    titles: {
      visibility: 'נראות',
      layerDate: 'נתוני שכבה',
      visualRepresenatation: 'ייצוג חזותי',
    },

    filters: {
      status: {
        title: 'סטטוס',
        placeholder: 'סטטוס',
        options: {
          new: 'חדש',
          on_hold: 'בהמתנה',
          routing: 'בהפקה',
          routed: 'נותב',
          canceled: 'בוטל',
          picked: 'נאסף',
          dropped: 'הורד',
          noshow: 'לא הופיע',
          queued: 'בתור',
        },
      },

      zones: {
        title: 'אזור',
      },

      powerType: {
        title: 'הספק טעינה',
        placeholder: 'הספק טעינה',
        options: {
          fast: 'מהיר',
          slow: 'איטי',
          turbo: 'טורבו',
        },
      },

      connectorType: {
        title: 'סוג מחבר',
        placeholder: 'סוג מחבר',
        options: {
          EC_Type_1: 'IEC סוג 1',
          IEC_Type_2_J1772: 'IEC סוג 2 (J1772)',
          IEC_Type_2: 'IEC סוג 2',
          IEC_Type_3: 'IEC סוג 3',
          CHAOJI: 'CHAOJI',
          NEMA: 'NEMA',
          TESLA: 'TESLA',
          CHADEMO: 'CHADEMO',
          GBT: 'GBT',
        },
      },
    },

    content: {
      traffic: {
        title: 'תנועה',
        description: 'תיאור שכבה המסביר מה אנו מציגים על המפה',
        mildlyhigher: 'גבוה במעט',
        trafficJam: 'פקק תנועה',
      },

      evsChargingPoints: {
        title: 'נקודות טעינה לרכבים חשמליים',
        description: 'תיאור שכבה המסביר מה אנו מציגים על המפה',
        chargingPointOptions: {
          fast: 'נקודת טעינה מהירה',
          slow: 'נקודת טעינה איטית',
        },
      },

      heatMap: {
        title: 'מפת חום',
        description: 'תיאור שכבה המסביר מה אנו מציגים על המפה',
        scaleOfDemand: 'מדד הביקוש',
      },

      dots: {
        title: 'נקודות',
        description: 'תיאור שכבה המסביר מה אנו מציגים על המפה',
        numberOfDemands: 'מספר הביקוש',
      },

      tripsLiveStream: {
        title: 'שידור חי של נסיעות',
        description: 'תיאור שכבה המסביר מה אנו מציגים על המפה',
        tripProgress: 'התקדמות נסיעה',
        pickUp: 'איסוף',
        dropOff: 'הורדה',
      },
    },
  },

  kpis: {
    title: 'מדדי ביצוע',

    titles: {
      driversAndVehicles: 'נהגים ורכבים',
      routes: 'מסלולים',
    },
  },
};

export default missionControl;
